import { Observable } from 'rxjs';
import { MacroDataService, MacroService } from '../ap-macro/services/index';

export interface MacroInterfaces {

  // Client code must set these values
  supportedMacroInterfaceTypes: MacroInterfaceTypes[];
  editorName: string;
  editorId: string;
  dxId: string;

  // Client code should override as needed

  getRtext: () => string;
  setPtext: (ptext: string) => void;
  getSame: () => string | undefined | null;
  getSameNote: () => string | undefined | null;

  // Implementation must set these values

  macroService: MacroService;
  macroDataService: MacroDataService;

  setup: (editorName: string, macroTypes: MacroInterfaceTypes[]) => void;

  closeObs(): Observable<boolean>;
}

export enum MacroInterfaceTypes {
  ptext = 'ptext',
  rtext = 'rtext',
  same = 'same',
  samenote = 'samenote',
}

export enum EditorName {
  patient_story = 'patient_story',
}
